module.exports = __webpack_public_path__ + "static/media/2019-06-03-01.e6757dde.jpg";